import { render } from "./CollectionsGrid.vue?vue&type=template&id=c49c91ca&scoped=true"
import script from "./CollectionsGrid.vue?vue&type=script&lang=js"
export * from "./CollectionsGrid.vue?vue&type=script&lang=js"

import "./CollectionsGrid.vue?vue&type=style&index=0&id=c49c91ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49c91ca"]])

export default __exports__